import React from "react";
import Lottie from "lottie-react";
import groovyWalkAnimation from "../../Assets/loader.json";

const Loader = () => <Lottie animationData={groovyWalkAnimation} loop={true} />;

export default Loader;
